import React from 'react';
import SampleImage from '../../assets/images/productimage/car (1).jpg';

function MyAds() {
  return (
    <div className="myads w-full p-8 bg-gray-50 min-h-screen px-[10%]">
      <h1 className="text-4xl font-extrabold text-gray-800 mb-6">My Ads</h1>

      <table className="w-full border-collapse bg-white shadow-lg rounded-lg overflow-hidden">
        <thead className="bg-gray-100 text-left text-sm uppercase text-gray-600 tracking-wide">
          <tr>
            <th className="py-4 px-6">Ad Name</th>
            <th className="py-4 px-6">Main Image</th>
            <th className="py-4 px-6">Slide Images</th>
            <th className="py-4 px-6">Description</th>
            <th className="py-4 px-6">Address</th>
            <th className="py-4 px-6">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr className="hover:bg-gray-50 border-b">
            <td className="py-4 px-6 font-medium text-gray-800">
              Immediate Sell - Toyota Harrier
            </td>
            <td className="py-4 px-6">
              <img
                src={SampleImage}
                alt="Main Ad"
                className="w-14 h-10 object-contain rounded-lg shadow-md"
              />
            </td>
            <td className="py-4 px-6">
              <div className="flex gap-2">
                {[...Array(5)].map((_, index) => (
                  <img
                    key={index}
                    src={SampleImage}
                    alt={`Slide ${index + 1}`}
                    className="w-14 h-10 object-contain rounded-lg shadow-md"
                  />
                ))}
              </div>
            </td>
            <td className="py-4 px-6 text-gray-700">
              <p>Selling fast! Great condition and well-maintained.</p>
            </td>
            <td className="py-4 px-6 text-gray-700">Vavuniya, Sri Lanka</td>
            <td className="p-4">
            <div className="flex justify-center space-x-2">

              <button className="hover:text-gray-600">
              <i className="fas fa-eye"></i>
              </button>
              <button className=" text-primary">
              <i className="fas fa-edit"></i>

              </button>
              <button className="text-red-600">
              <i className="fas fa-trash"></i>

              </button>

            </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}

export default MyAds;
